module.exports = __webpack_public_path__ + "img/fuel.df9cdcdb.png";